export const labels = {
	save: {
		label: "Label.MobileCreator.Toolbar.Save",
		default: "Save project",
	},
	saveNotification: {
		label: "Label.MobileCreator.Notification.Save",
		default: "Product saved",
	},
	restartProduct: {
		label: "Label.MobileCreator.Toolbar.RestartProduct",
		default: "Restart product",
	},
	info: {
		label: "Label.MobileCreator.Toolbar.Info",
		default: "Info",
	},
	infoContent: {
		label: "Label.HTML5Editor.HelpBubble.Content",
		default: "",
	},
	savedProducts: {
		label: "Label.MobileCreator.Toolbar.SavedProducts",
		default: "Saved Products",
	},
	productWarnings: {
		label: "Label.MobileCreator.Toolbar.ProductWarnings",
		default: "{0} Product warnings",
	},
} as const;

export const dynamicLabels = {
	infoMessageProduct: (product?: string) => {
		if (!product) return undefined;

		return {
			// added '.Product' in label name, because for Al-Bookmarks the
			// productCode is 'bookmark' and ProductCategory is 'Bookmark'
			label: `Label.MobileCreator.ProductInfo.Product.${product}`,
			default: "",
			logMissingToServer: false,
		};
	},
	infoMessageProductCategory: (productCategory?: string) => {
		if (!productCategory) return undefined;

		return {
			label: `Label.MobileCreator.ProductInfo${productCategory.substring(
				productCategory.indexOf("."),
			)}`,
			default: "",
			logMissingToServer: false,
		};
	},
};
